import React, { useState, useContext, useEffect } from "react";
import { Form } from "semantic-ui-react";
import Result from "../../../../common/repository/Result";
import { toast } from "../../../common/Toast";
import InvoiceSectionRepository from "../../../../common/repository/InvoiceSectionRepository";

function UploadBulkInvoiceForm({ onSuccess }: Props) {
  const [isLoading, setIsLoading] = useState(false);
  const [file, setFile] = useState<File | null>(null);
  const invoiceRepo = new InvoiceSectionRepository();

  useEffect(() => {
    uploadSheet();
  }, [isLoading, file]);

  return (
    <Form loading={isLoading}>
      <Form.Input
        type="file"
        label="Choose Invoice Template Sheet"
        accept=".xlsx"
        onChange={(e) => {
          if (e.target.files) setFile(e.target.files[0]);
          else setFile(null);
        }}
      />
      <Form.Button
        positive
        disabled={isLoading || file === null}
        onClick={() => setIsLoading(true)}
      >
        Submit
      </Form.Button>
    </Form>
  );

  async function uploadSheet() {
    if (!isLoading || file === null) return;
    const result = await invoiceRepo.uploadInvoicePendencySheet(file);
    if (result instanceof Result.Success) {
      if (result.data.items.length == 0)
        toast.success("Data uploaded successfully");
      else {
        toast.success("Data uploaded successfully, But some rows are skipped!");
      }

      if (onSuccess) onSuccess(result.data.items);
    } else {
      const message = result.message || "Something went wrong";
      toast.error(message);
    }
    setIsLoading(false);
  }
}

interface Props {
  onSuccess?(items: any): any;
}

export default UploadBulkInvoiceForm;
